import { Component, input, output } from "@angular/core";
import { InitResponse } from "src/app/shared/contract/Init/InitDataResponse";
import { MatIcon } from "@angular/material/icon";
import { MatDivider } from "@angular/material/divider";
import { MatMenuItem } from "@angular/material/menu";
import { TranslocoPipe } from "@jsverse/transloco";

@Component({
  selector: "app-user-menu",
  templateUrl: "./user-menu.component.html",
  styleUrl: "./user-menu.component.scss",
  imports: [MatIcon, MatDivider, MatMenuItem, TranslocoPipe]
})
export class UserMenuComponent {
  readonly initData = input.required<InitResponse>();
  readonly quota = input<number>(undefined);
  readonly hasShopPermission = input(false);
  readonly hasAppSynchronizationPermission = input(false);
  readonly hasChangeRightPermission = input(undefined);
  readonly locale = input("de");

  readonly showMobileTAN = output();
  readonly showPackageOverview = output();
  readonly changeRight = output();
  readonly logout = output();
  readonly redeemCode = output();

  emitShowMobileTAN() {
    this.showMobileTAN.emit();
  }

  emitChangeRight() {
    this.changeRight.emit();
  }

  emitShowPackageOverview() {
    this.showPackageOverview.emit();
  }

  emitLogout() {
    this.logout.emit();
  }
}
